import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { TranslationService } from '../services/services.index';
import { User } from '../models/user.model';

import { UserService } from '../services/services.index';

import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;
declare var $;
declare function init_plugins();

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  // tslint:disable-next-line:no-inferrable-types
  recuerdame: boolean = false;
  email: string;

  auth2: any;

  loading: boolean = false;

  constructor(public router: Router,
              public _translationService: TranslationService,
              public _userService: UserService) {
              }

  ngOnInit() {
      init_plugins();
      // Si el recuerdame se activo
      this.email = localStorage.getItem('email') || '';
      if (this.email.length > 1) {
        this.recuerdame = true;
      }
  }

  ingresar (forma: NgForm) {
    this.loading = true;
    if ( forma.invalid ) {
      this.loading = false;
      return;
    }

    // tslint:disable-next-line:prefer-const
    let user = new User(
      null,
      forma.value.email,
      forma.value.password
    );

    this._userService.login(user, forma.value.recuerdame)
                        .subscribe(correcto => {
                            this.loading = false;
                            if (this._userService.user.role === 'ADMIN_ROLE') {
                              this.router.navigate(['/escritorio-admin']);
                            } else {
                              this.router.navigate(['/dashboard']);
                            }
                          },
                          err => {
                            this.loading = false;
                            console.log(err);
                          }
                          );
  }

  switchLanguage(language: string) {
    this._translationService.switchLanguage( language );
  }

  recuperarPassword() {
    let lang: string = this._translationService.lang;
    let message: string;
    let messageSuccess: string;
    let titleSuccess: string;
    if (lang === 'es') {
      message = 'Ingrese el email de la cuenta que desea recuperar.';
      messageSuccess = 'El código de recuperacion fue enviado al email, siga las instrucciones para generar un nuevo password. Muchas Gracias.';
      titleSuccess = 'Código Enviado';
    } else if (lang === 'en') {
      message = 'Enter the email of the account you wish to recover.';
      messageSuccess = 'The recovery code was sent to the email, follow the instructions to generate a new password. Thank you so much.';
      titleSuccess = 'Code Sent';
    }

    swal({
      content: {
        element: 'input',
        attributes: {
          placeholder: message,
          type: 'email',
        },
      },
    })
    .then((emailRecuperacion) => {
      if (emailRecuperacion) {
        this._userService.recuperarPassword(emailRecuperacion).subscribe(resp => {
          swal(titleSuccess, messageSuccess, 'success');
        });
      }
    });
  }

  // function to decide if mobile or not
  isMobile() {
    return ($(window).width() < 767);
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts